<div class="app-container">
	<nav-header
		*ngIf="hasFinishedLoading"
		[menu]="navigation?.header"
		[user]="navigation?.userProfile"
		[showNewLogin]="true"
		[showAgentSubHeaderFeature]="true"
		[sideMenuOpen]="showSideMenu"
		[routerAtHome]="routerAtHome"
		[sideMenuCollapsed]="sideMenuCollapsed"
		[sideMenuDraggables]="sideMenuDraggables"
		[sidebarData]="navigation?.sidebar ? navigation?.sidebar.menu : null"
		[showClientLoginFeature]="false"
		[domain]="domain"
		[featureQueueList]="featureQueueList"
		[activeRoute]="activeRoute"
		[showHeaderMenu]="showHeaderMenu"
		[applications]="navigation?.application?.menuItem || []"
		(openFacModal)="openFacModal($event)"
		(sideMenu)="toggleSideMenu()"
		(loggedIn)="successfulLogin($event)"
		(sendUrl)="getURL($event)"
		(logout)="logout($event)"
		(sideMenuAction)="sideMenuAction($event)"
		(addDashWidget)="addDashWidget($event)"
		(snackbarMessage)="showSnackbar($event)"
		(pushTagEventToAnalytics)="pushTagEvent($event)"
		[featureReleaseNotes]="featureReleaseNotes"
		[portalUrl]="portalUrl"
		[isCrm]="true"
	></nav-header>
	<router-outlet></router-outlet>
	<app-snackbar></app-snackbar>
	<app-buttons-popup></app-buttons-popup>
	<nav-footer
		*ngIf="hasFinishedLoading && showFooter"
		[footer]="navigation?.footer"
		[showStoreButtons]="false"
		[portalUrl]="portalUrl"
	></nav-footer>
</div>

<app-edit-fac-modal *ngIf="showModal" [facdId]="facId" [show]="showModal" (closeM)="closeModal()"></app-edit-fac-modal>
